interface Target {
  id: string;
  numero: string;
  familiares: number;
}

interface Props {
  target: Target;
  confirmText: string;
  setConfirmText: (s: string) => void;
  error: string | null;
  submitting: boolean;
  puedeConfirmar: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function EliminarLegajoModal({
  target,
  confirmText,
  setConfirmText,
  error,
  submitting,
  puedeConfirmar,
  onCancel,
  onConfirm,
}: Props) {
  const familiaresLine =
    target.familiares > 0
      ? ` y ${target.familiares} familiar${target.familiares > 1 ? 'es' : ''}`
      : '';

  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,37,100,0.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 50,
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget && !submitting) onCancel();
      }}
    >
      <div
        className="card"
        style={{
          maxWidth: 480,
          width: 'calc(100% - 32px)',
          background: 'white',
          padding: '1.5rem',
        }}
      >
        <h2
          className="heading-5"
          style={{ marginBottom: 8, color: 'var(--color-error-dark)' }}
        >
          Eliminar legajo {target.numero}
        </h2>
        <p className="text-element-mid" style={{ fontSize: 14, marginBottom: 14 }}>
          Vas a borrar el legajo <strong>{target.numero}</strong>, su titular
          {familiaresLine}, junto con sus respuestas del cuestionario y OTPs. Esta acción
          <strong> no se puede deshacer</strong>.
        </p>
        <p className="text-element-mid" style={{ fontSize: 13, marginBottom: 8 }}>
          Para confirmar, escribí <code style={{ fontWeight: 700 }}>{target.numero}</code>:
        </p>
        <input
          className="input"
          value={confirmText}
          onChange={(e) => setConfirmText(e.target.value)}
          disabled={submitting}
          autoFocus
          placeholder={target.numero}
        />
        {error && (
          <p className="status status-error" style={{ display: 'block', marginTop: 10 }}>
            {error}
          </p>
        )}
        <div
          style={{
            display: 'flex',
            gap: 8,
            justifyContent: 'flex-end',
            marginTop: 18,
          }}
        >
          <button className="btn btn-ghost" onClick={onCancel} disabled={submitting}>
            Cancelar
          </button>
          <button
            className="btn btn-primary"
            onClick={onConfirm}
            disabled={!puedeConfirmar}
            style={{ background: 'var(--color-error-dark)' }}
          >
            <span className="btn-font-style">
              {submitting ? 'Eliminando…' : 'Eliminar legajo'}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}
